import axios from 'axios';
import { getCookie, isWebView, setCookie } from 'utils/commonFunctions';
import config from 'utils/config';
import { urlTemplates } from './urls';

const createAxiosInstance = (baseURL) => {
  const axiosInstance = axios.create({
    baseURL: baseURL,

    headers: {
      'x-icc-token': getCookie('icc-game-cookie')?.game_session_token,
      'Content-Type': 'application/json',
      Accept: 'application/json',
      entity: config.entity
    },

    withCredentials: true
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      const cookie = getCookie('icc-game-cookie');
      if (cookie?.game_session_token) {
        config.headers['x-icc-token'] =
          config.headers?.['x-icc-token'] ?? cookie?.game_session_token;
      }

      let buster;
      if (config.addBuster) {
        buster = Date.now();
      }

      config.params = {
        ...config.params,
        buster
      };

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    async (response) => {
      if (isWebView()) {
        if (response?.data?.Meta?.RetVal === -555) {
          try {
            const loginToken = await window?.standaloneTopPicks?.getAccessToken();
            const res = await axios.post(
              process.env.API_BASE_URL + '/user/login',
              { optType: 1, platformId: 3, userId: 0, clientId: 1, gameName: 'top-picks' },
              {
                headers: {
                  'x-icc-token': loginToken,
                  entity: config.entity
                }
              }
            );

            if (res.data?.Meta?.RetVal === 1) {
              setCookie('icc-game-cookie', JSON.stringify(res?.data?.Data?.Value));
              window.location.reload();
            }
          } catch (error) {
            console.log(error);
          }

          if (!res.config.retryApiCall) {
            res.config.retryApiCall = true;

            res.config.headers['x-icc-token'] = getCookie('icc-game-cookie')?.game_session_token;

            return axiosInstance(response.config);
          }
        }
      } else if (response.data.Meta.RetVal === -555) {
        const { setIsExpireToken } = window.si_icc_access_token;
        window.si_expire_session = true;
        window.si_count = window.si_count ? window.si_count + 1 : 1;
        setIsExpireToken({ flag: true, retVal: response.data.Meta.RetVal });
      }
      // if (response?.data?.Meta?.Success === false) {
      //   return Promise.reject({
      //     data: response?.data?.Meta
      //   });
      // }
      // if (response?.data?.Data?.Value !== undefined) {
      //   response.data = response?.data?.Data?.Value;
      // }
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default createAxiosInstance;
